import React, { ReactNode } from 'react';
import { ActivityIndicator, TouchableOpacityProps } from 'react-native';
import { Feather } from '@expo/vector-icons';
// import { useTheme } from 'styled-components/native';
import debounce from 'lodash/debounce';

import { Container, Title } from './styles';
import { themes } from '../../design/colors';

interface ButtonProps extends TouchableOpacityProps {
  title: string;
  onPress: () => void;
  disabled?: boolean;
  autoSize?: boolean;
  color?: string;
  background?: string;
  loading?: boolean;
  icon?: keyof typeof Feather.glyphMap;
  children?: ReactNode;
}

/**
 *  Principais botões.
 *  - `title`: Texto principal do botão
 *  - `type`: Tipo do botão de acordo com o Design System (default: `filled`)
 *  - `onPress`: Função realizada ao pressionar o botão
 *  - `autoSize?`: Opção para o botão ficar ajustado ao tamanho do título
 *  - `disabled?`: Desabilitar o botão, altera as cores e impede o clique
 *  - `icon?`: Nome do ícone (Feather) exibido antes do título
 */
export default function Button({
  title,
  onPress,
  disabled,
  autoSize,
  children,
  color,
  loading,
  background,
  icon,
}: ButtonProps) {
  return (
    <Container
      disabled={disabled}
      onPress={debounce(onPress, 800, { leading: true, trailing: false })}
      background={background}
    >
      {loading ? (
        <ActivityIndicator animating color={themes.colors.white} size={'small'} />
      ) : (
        <>
          {icon && (
            <Feather
              name={icon}
              size={18}
              color={color ?? themes.colors.white}
              style={{ marginRight: 8 }}
            />
          )}
          <Title color={color}>{title}</Title>
        </>
      )}
    </Container>
  );
}
